import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'element-ui/packages/theme-chalk/lib/index.css'

import Element from 'element-ui'
import HonjoUI from '@@/index'
import '@@/styles/index.scss'
import '@@/styles/icons/iconfont.css'
Vue.config.productionTip = false

Vue.use(Element)
Vue.use(HonjoUI)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
